<template>
  <div class="round" :style="{ backgroundColor: color }"></div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

const map = {
  having: "#95F204",
  once: "#F59A23",
  nothave: "#AAAAAA",
};

export default defineComponent({
  isGlobal: true,
  name: "HmdRound",
  props: {
    type: {
      type: String,
      default: "nothave",
    },
  },
  setup(props, { attrs, slots, emit }) {
    // , width: '3px',height: '3px', borderRadius: '50%'
    const color = ref(map[props.type]);
    return { color };
  },
});
</script>
<style lang="less" scoped>
  .round {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin-right: 3px;
  }
</style>
